import type { SubjectQuoteDatabase } from '../../../types';
import { formatQuoteAmount } from './formatQuoteAmount';

export type PendingQuoteRow = {
  id: string;
  providerName: string;
  /** Context line, followed by a mention when the amount is missing (kept out of the narrow amount column). */
  subtitle: string | null;
  formattedAmount: string | null;
};

type QuoteWithProvider = SubjectQuoteDatabase & {
  providers?: { name: string } | null;
};

/** `context` is what the row needs to be told apart: the quote title, or its sub-topic outside of it. */
export function toPendingQuoteRow(quote: QuoteWithProvider, context: string | null): PendingQuoteRow {
  const formattedAmount = quote.amount == null ? null : formatQuoteAmount(Number(quote.amount));
  const subtitleParts = [context, formattedAmount ? null : 'Montant non renseigné'].filter(Boolean);

  return {
    id: quote.id,
    providerName: quote.provider_name ?? quote.providers?.name ?? 'Prestataire non renseigné',
    subtitle: subtitleParts.length > 0 ? subtitleParts.join(' · ') : null,
    formattedAmount,
  };
}
